module.exports = "<div class=\"loading-wrap\" *ngIf=\"loading\">\r\n  <div class=\"loading-box\"></div>\r\n</div>\r\n"